import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { StandbyOrder, StandbyOrderSearchFilters } from "../../types/standbyOrder";
import { searchStandbyOrdersApi } from "../../api/standbyOrdersApi";
import type { PaginationParam, PaginationResponse } from "../../types/paginationResponse";

interface StandbyOrderState {
  standbyOrders: StandbyOrder[];
  loading: boolean;
  error: string | null;
  pagination: PaginationResponse | null;
}

const initialState: StandbyOrderState = {
  standbyOrders: [],
  loading: false,
  error: null,
  pagination: null,
};

export const searchStandbyOrders = createAsyncThunk<
  { standbyOrders: StandbyOrder[]; pagination: PaginationResponse },
  { filters?: StandbyOrderSearchFilters; pagination?: PaginationParam },
  { rejectValue: string }
>("standbyOrders/search", async ({ filters, pagination }, { rejectWithValue }) => {
  try {
    return await searchStandbyOrdersApi(filters, pagination);
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || "Failed to search standby orders");
  }
});

const standbyOrderSlice = createSlice({
  name: "standbyOrders",
  initialState,
  reducers: {
    clearStandbyOrdersError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchStandbyOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchStandbyOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.standbyOrders = action.payload.standbyOrders;
        state.pagination = action.payload.pagination;
      })
      .addCase(searchStandbyOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? "Failed to search standby orders";
      });
  },
});

export const { clearStandbyOrdersError } = standbyOrderSlice.actions;
export default standbyOrderSlice.reducer;
